<script>
import Swal from "sweetalert2";
import { bus } from "@/main.js";
export default {
  methods: {
    // this function gives us dynamic routing 1st router link
    getCurrentNav(updated_nav) {
      if (updated_nav) {
        const redirectLink =
          updated_nav[0] &&
          updated_nav[0]._children[0] &&
          updated_nav[0]._children[0].to;
        if (redirectLink) {
          this.$router.push({ path: `${redirectLink}` });
        } else {
          let chieldRedirectLink =
            updated_nav[0] &&
            updated_nav[0]._children[0] &&
            updated_nav[0]._children[0].items[0] &&
            updated_nav[0]._children[0].items[0].to;
          this.$router.push({ path: `${chieldRedirectLink}` });
        }
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    forShortAddress: function (obj) {
      let address_lien_2 = obj.sublocality_level_2
        ? obj.sublocality_level_2 + ", "
        : "";
      let address_lien_1 = obj.sublocality_level_1
        ? obj.sublocality_level_1 + ", "
        : "";
      let city = obj.city + ". ";
      return address_lien_2 + address_lien_1 + city;
    },
  },
};
</script>
